import { IPublicClientApplication, SilentRequest } from "@azure/msal-browser";

import { hasElements, hasNoElements } from "../Utils/Array";
import { Configuration } from "../Utils/Configuration";

export async function aquireToken(
  instance: IPublicClientApplication,
  config: Configuration,
  requestConfig: Partial<SilentRequest> = {}
): Promise<void> {
  try {
    await instance.acquireTokenSilent({
      ...getScopes(config),
      ...getActiveAccount(instance),
      ...requestConfig
    });
  } catch {
    await instance.loginRedirect({
      ...getScopes(config)
    });
  }
}

function getActiveAccount(instance: IPublicClientApplication): Pick<SilentRequest, "account"> {
  const activeAccount = instance.getActiveAccount();
  const accounts = instance.getAllAccounts();

  if (activeAccount == null && hasNoElements(accounts)) {
    throw new Error(`No active account to aquire token silently. Trigger login again.`);
  }

  return {
    account: activeAccount ?? accounts[0]
  };
}

export function getScopes(config: Configuration): Pick<SilentRequest, "scopes"> {
  const authConfig = config.getAuth();
  const scopes = hasElements(authConfig?.scopes) ? authConfig.scopes : [`Backend.Use`];
  const { clientId } = authConfig;

  return {
    scopes: scopes.map((scope) => `api://${clientId}/${scope}`)
  };
}

export async function logout(instance: IPublicClientApplication): Promise<void> {
  try {
    await instance.logoutRedirect();
  } catch (e) {
    console.error(e);
  }
}
